import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { ICurrentUser } from '../../entities/Login/CurrentUser.ts';

export type HcpActivation = {
    mobileLast4: string;
    language: string;
    stopped: boolean;
};

export type HcpActivationCodePostModel = {
    token: string;
    code: string;
};

export type HcpActivationCompletePostModel = {
    token: string;
    password: string;
};

export class HcpActivationApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/HcpActivation`;

    public static apiUrls = {
        open: `${HcpActivationApi.baseApiUrl}/Open`,
        sendCode: `${HcpActivationApi.baseApiUrl}/SendCode`,
        verifyCode: `${HcpActivationApi.baseApiUrl}/VerifyCode`,
        complete: `${HcpActivationApi.baseApiUrl}/Complete`,
    };

    public static async open(token: string): Promise<HcpActivation> {
        return this.sendApiRequest<HcpActivation>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.open,
            data: { token },
            suppressGlobalErrorHandling: true,
        });
    }

    public static async sendCode(token: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.sendCode,
            data: { token },
            suppressGlobalErrorHandling: true,
        });
    }

    public static async verifyCode(token: string, code: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.verifyCode,
            data: { token, code },
            suppressGlobalErrorHandling: true,
        });
    }

    public static async complete(token: string, password: string): Promise<ICurrentUser> {
        return this.sendApiRequest<ICurrentUser>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.complete,
            data: { token, password },
            suppressGlobalErrorHandling: true,
        });
    }
}
